<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-bind="payment"
    />
    <BaseNote
      v-bind="note"
      class="screen__bottom-note"
    >
      <FieldEmail
        ref="field"
        v-bind="field"
        v-model="email"
        class="note__field"
      />
    </BaseNote>
  </BaseScreen>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import CONSTANTS from '@/helpers/constants';

import screenMixin from '@/mixins/screen';

import BaseNote from '@/components/BaseNote.vue';
import FieldEmail from '@/components/FieldEmail.vue';

export default {
  name: 'ConfirmScreen',
  mixins: [screenMixin],
  components: {
    BaseNote,
    FieldEmail,
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapState('personal', [
      'profile',
    ]),
    ...mapGetters('personal', [
      'isAuthenticated',
    ]),
    ...mapGetters('payment', [
      'sum',
      'balance',
    ]),
    screenCase() {
      return CONSTANTS.STEP_CONFIRM_PAY;
    },
    balanceText() {
      const isNegative = this.balance < 0;
      const label = isNegative ? 'texts.creditAfterPay' : 'texts.balanceAfterPay';
      const sum = this.$options.filters.sum(this.balance);
      const sumType = isNegative ? 'sum_negative' : 'sum_positive';
      const balance = `<span class="sum ${this.balance === 0 ? '' : sumType}">${sum}</span>`;
      return this.$t(label, { balance });
    },
    payment() {
      return {
        icon: {
          name: 'wallet',
          theme: 'primary',
          size: 'l',
        },
        title: {
          text: this.$t('titles.pay', { sum: this.$options.filters.sum(this.sum) }),
          size: 'l',
        },
        description: this.isAuthenticated ? {
          text: this.balanceText,
          size: 'l',
        } : null,
        actions: [
          {
            text: this.$t('actions.noGoBack'),
            action: this.goToBackScreen,
            view: 'outlined',
          },
          {
            text: this.$t('actions.yesPay'),
            action: this.goToPayScreen,
          },
        ],
        'data-animation': '',
      };
    },
    field() {
      return {
        label: '',
        required: false,
      };
    },
    note() {
      return {
        description: {
          text: this.$t('texts.checkEmail'),
        },
      };
    },
  },
  created() {
    this.setProfileEmail();
    this.initActions([
      [CONSTANTS.ACTION_DISAGREE, this.goToBackScreen],
      [CONSTANTS.ACTION_AGREE, this.goToPayScreen],
    ]);
  },
  methods: {
    ...mapMutations('payment', [
      'setEmail',
    ]),
    setProfileEmail() {
      this.email = this.profile?.email || '';
    },
    goToPayScreen() {
      // const isEmailValid = this.$refs.field.checkValidity();
      // if (isEmailValid) {
      //   this.setEmail(this.email);
      //   this.$router.push(this.$router.options.paths.pay);
      // } else {
      //   this.$refs.field.focus();
      // }
      this.setEmail(this.email);
      this.$router.push(this.$router.options.paths.pay);
    },
  },
};
</script>
